import { H3 } from '@blueprintjs/core';
import { HeartBeatsData } from '../../types';

interface HeartBeatsProps {
  data: HeartBeatsData;
}
const HeartBeats = ({ data }: HeartBeatsProps) => {
  const fromPeaks = data?.heart_rate_from_peaks;
  const fromValleys = data?.heart_rate_from_valleys;

  return (
    <>
      <H3>Resultado da Técnica:</H3>
      {(fromPeaks || fromValleys) && (
        <ul>
          {fromPeaks && (
            <li>
              <strong>Batimento cardíaco dos picos</strong>: {fromPeaks}
            </li>
          )}
          {fromValleys && (
            <li>
              <strong>Batimento cardíaco dos vales</strong>: {fromValleys}
            </li>
          )}
        </ul>
      )}
    </>
  );
};

export default HeartBeats;
